import {
  WORLD_DOTS_PATH,
  WORLD_VIEWBOX,
  CITY_POINTS,
} from "@/components/world/worldMapData";
import { arcFor } from "@/components/world/arcs";

const APAC = ["tokyo", "seoul", "shanghai", "bangkok", "singapore", "jakarta"];
const GLOBAL = ["london", "newYork", "dubai", "frankfurt", "saoPaulo", "sydney", "sanFrancisco", "nairobi"];
const REACH = [
  ["hongKong", "london", 0.3],
  ["hongKong", "newYork", 0.22],
  ["hongKong", "dubai", 0.26],
  ["hongKong", "sydney", 0.3],
  ["hongKong", "sanFrancisco", 0.2],
];

export const GlobalMap = () => {
  const [hkX, hkY] = CITY_POINTS.hongKong;

  return (
    <svg
      viewBox={`0 0 ${WORLD_VIEWBOX.width} ${WORLD_VIEWBOX.height}`}
      className="h-auto w-full"
      aria-label="World map indicating Montaire Group headquarters in Hong Kong and international outlook"
      role="img"
    >
      <defs>
        <radialGradient id="hkGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="hsl(var(--aqua-bright))" stopOpacity="0.45" />
          <stop offset="100%" stopColor="hsl(var(--aqua-bright))" stopOpacity="0" />
        </radialGradient>
        <linearGradient id="reachLine" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="hsl(var(--aqua-bright))" stopOpacity="0.55" />
          <stop offset="100%" stopColor="hsl(var(--aqua))" stopOpacity="0.04" />
        </linearGradient>
      </defs>

      <path d={WORLD_DOTS_PATH} fill="hsl(var(--mist))" opacity="0.28" />

      {REACH.map(([a, b, lift], i) => (
        <path
          key={b}
          d={arcFor(a, b, lift)}
          fill="none"
          stroke="url(#reachLine)"
          strokeWidth="0.8"
          strokeDasharray="1000"
          style={{ animation: `montaire-draw ${16 + i * 2}s linear ${i * 2.2}s infinite` }}
        />
      ))}

      {GLOBAL.map((key) => {
        const [x, y] = CITY_POINTS[key];
        return <circle key={key} cx={x} cy={y} r="2" fill="hsl(var(--mist))" opacity="0.6" />;
      })}

      {APAC.map((key, i) => {
        const [x, y] = CITY_POINTS[key];
        return (
          <circle
            key={key}
            cx={x}
            cy={y}
            r="2.4"
            fill="hsl(var(--aqua))"
            opacity="0.75"
            style={{
              transformOrigin: `${x}px ${y}px`,
              animation: `montaire-pulse ${7 + (i % 3)}s ease-in-out ${i * 0.6}s infinite`,
            }}
          />
        );
      })}

      <circle cx={hkX} cy={hkY} r="48" fill="url(#hkGlow)" />
      <circle
        cx={hkX}
        cy={hkY}
        r="14"
        fill="none"
        stroke="hsl(var(--aqua-bright))"
        strokeWidth="0.7"
        opacity="0.5"
        style={{
          transformOrigin: `${hkX}px ${hkY}px`,
          animation: "montaire-pulse 5s ease-in-out infinite",
        }}
      />
      <circle cx={hkX} cy={hkY} r="4" fill="hsl(var(--aqua-bright))" />

      <g>
        <line
          x1={hkX - 6}
          y1={hkY - 6}
          x2={hkX - 50}
          y2={hkY - 50}
          stroke="hsl(var(--aqua-bright))"
          strokeWidth="0.6"
          opacity="0.7"
        />
        <line
          x1={hkX - 50}
          y1={hkY - 50}
          x2={hkX - 200}
          y2={hkY - 50}
          stroke="hsl(var(--aqua-bright))"
          strokeWidth="0.6"
          opacity="0.7"
        />
        <text
          x={hkX - 54}
          y={hkY - 60}
          textAnchor="end"
          fill="hsl(var(--off-white))"
          fontSize="22"
          letterSpacing="3"
          fontFamily="IBM Plex Mono, monospace"
        >
          HONG KONG
        </text>
        <text
          x={hkX - 54}
          y={hkY - 36}
          textAnchor="end"
          fill="hsl(var(--aqua-bright))"
          fontSize="14"
          letterSpacing="3"
          fontFamily="IBM Plex Mono, monospace"
        >
          GROUP HEADQUARTERS
        </text>
      </g>
    </svg>
  );
};
